//
// product-tagging-service.js
//
// Copyright (c) 2016 by Curalate, Inc.
//

/*global angular: false, _: false */

(function() {
    'use strict';

    var curalate = angular.module('curalate');

    curalate.service('ProductTaggingService', ['$http', '$q', '$rootScope', 'PromiseService', 'RestBaseUrl', 'UniversalImageActionsTrackingService',
        function($http, $q, $rootScope, PromiseService, RestBaseUrl, UniversalImageActionsTrackingService) {
            var products,
                productsErrorState,
                itemId,
                originalProducts,
                validateProducts,
                saveProductsAsync,
                convertProductIdsToNumbers,
                convertCrawledImageUrlsToObjects,
                convertCrawledImageUrlsToStrings,
                affiliateParams,
                updateProductPositionsAndLabels,
                hasMissingProductImageOrName,
                hasInvalidProductUrl,
                sortProducts,
                VALIDATION_ERRORS,
                self = this;

            VALIDATION_ERRORS = {
                MissingImageOrName: 'To save, all products need images and names.',
                InvalidUrl: 'To save, all product URLs must be valid.'
            };

            this.saveProductTagsAsync = function(products) {
                var storeId, networkIdentifier;

                if (!itemId) {
                    throw 'Attempting to save products without an item ID';
                }

                if (affiliateParams) {
                    storeId = affiliateParams.storeId;
                    networkIdentifier = affiliateParams.networkIdentifier;

                    // Affiliate clients cannot hit the UIA REST API because their products do not have productStyleIds
                    return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/like2buy/' + storeId + '/item/' + networkIdentifier + '/products', {
                        products: products
                    }), true);
                } else {
                    return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/universal-image-actions/items/' + itemId + '/products', { products: products }));
                }
            };

            this.getProducts = function() {
                if (products !== undefined) {
                    return products;
                } else {
                    throw 'Product Tag Manager: Products not defined';
                }
            };

            this.setProducts = function(newProducts, setItemId) {
                var sortedProducts = sortProducts(newProducts);

                if (setItemId) {
                    itemId = setItemId;
                }

                if (!angular.equals(products, sortedProducts)) {
                    if (products === undefined) {
                        originalProducts = sortedProducts;
                    }

                    products = sortedProducts;
                    $rootScope.$broadcast('uia:products-changed', products);
                }
            };

            this.setAffiliateData = function(newAffiliateParams) {
                affiliateParams = angular.copy(newAffiliateParams);
            };

            this.addProductAsync = function(newProduct) {
                var newProducts = angular.copy(productsErrorState || products);

                UniversalImageActionsTrackingService.setProduct(newProduct);
                UniversalImageActionsTrackingService.saveRoute();

                newProducts.push(newProduct);
                return saveProductsAsync(newProducts);
            };

            this.removeProductAsync = function(productIndex) {
                var newProducts = angular.copy(productsErrorState || products);

                newProducts.splice(productIndex, 1);
                return saveProductsAsync(newProducts);
            };

            this.updateProductsAsync = function(newProducts) {
                return saveProductsAsync(sortProducts(newProducts));
            };

            this.getOriginalProducts = function() {
                return originalProducts;
            };

            this.updateProductAsync = function(newProduct, productIndex) {
                var newProducts = angular.copy(productsErrorState || products),
                    originalProduct = newProducts[productIndex];

                if (!newProduct.fileId && originalProduct) {
                    newProduct.fileId = originalProduct.fileId;
                }

                newProducts[productIndex] = newProduct;
                return saveProductsAsync(newProducts);
            };

            saveProductsAsync = function(newProducts) {
                var error, errorState, productsPromise;

                convertProductIdsToNumbers(newProducts);
                convertCrawledImageUrlsToStrings(newProducts);
                updateProductPositionsAndLabels(newProducts);
                newProducts = sortProducts(newProducts);
                error = validateProducts(newProducts);

                if (error) {
                    productsErrorState = angular.copy(newProducts);

                    errorState = {
                        errorMessage: error,
                        products: newProducts,
                        validationError: true
                    };

                    $rootScope.$broadcast('uia:invalid-products', errorState);
                    return $q.reject(errorState);
                }

                productsPromise = self.saveProductTagsAsync(newProducts).then(function(response) {
                    var newProducts = response.products;
                    productsErrorState = null;

                    if (!angular.equals(products, newProducts)) {
                        products = sortProducts(newProducts);

                        $rootScope.$broadcast('uia:products-changed', products);
                    }
                    return angular.copy(products);
                }).catch(function(error) {
                    productsErrorState = newProducts;
                    convertCrawledImageUrlsToObjects();

                    return $q.reject(error);
                });

                return productsPromise;
            };

            validateProducts = function(newProducts) {
                var containsMultipleProducts = newProducts && newProducts.length > 1;

                if (containsMultipleProducts && hasMissingProductImageOrName(newProducts)) {
                    return VALIDATION_ERRORS.MissingImageOrName;
                } else if (hasInvalidProductUrl(newProducts)) {
                    return VALIDATION_ERRORS.InvalidUrl;
                } else {
                    return null;
                }
            };

            // We need the product ids to be Longs when updating Like2Buy items
            convertProductIdsToNumbers = function(newProducts) {
                _(newProducts).each(function(product) {
                    product.id = product.id ? parseInt(product.id, 10) : null;
                });
            };

            // The db expects any lists of crawled image urls to be a JSON blob
            convertCrawledImageUrlsToStrings = function(newProducts) {
                _(newProducts).each(function(product) {
                    if (product.crawledImageUrls) {
                        product.crawledImageUrls = JSON.stringify(product.crawledImageUrls);
                    }
                });
            };

            convertCrawledImageUrlsToObjects = function(newProducts) {
                _(newProducts).each(function(product) {
                    if (product.crawledImageUrls) {
                        product.crawledImageUrls = JSON.parse(product.crawledImageUrls);
                    }
                });
            };

            updateProductPositionsAndLabels = function(newProducts) {
                var nextPosition = 1;
                _.chain(newProducts).sortBy(function(product) {
                    return product.spatialTag ? product.spatialTag : undefined;
                }).each(function(product) {
                    product.position = nextPosition;
                    if (product.spatialTag) {
                        product.spatialTag.label = nextPosition.toString();
                    }
                    nextPosition++;
                    return product;
                });
            };

            hasMissingProductImageOrName = function(newProducts) {
                return _(newProducts).some(function(product) {
                    return !product.imageUrl || !product.name;
                });
            };

            hasInvalidProductUrl = function(newProducts) {
                return _(newProducts).some(function(product) {
                    var url = product.destinationUrl;

                    return !url || url.trim().length === 0;
                });
            };

            sortProducts = function(productsList) {
                return _(productsList).sortBy(function(product) {
                    return product.position;
                });
            };
        }
    ]);

})();
